import { render, staticRenderFns } from "./CustomerViewStatistics.vue?vue&type=template&id=039da74f&scoped=true"
import script from "./CustomerViewStatistics.vue?vue&type=script&lang=js"
export * from "./CustomerViewStatistics.vue?vue&type=script&lang=js"
import style0 from "./CustomerViewStatistics.vue?vue&type=style&index=0&id=039da74f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039da74f",
  null
  
)

export default component.exports